import React, { FC, useEffect, useState } from "react";
import { DEMO_EXPERIENCES_LISTINGS } from "data/listings";
import { ExperiencesDataType, StayDataType } from "data/types";
import Pagination from "shared/Pagination/Pagination";
import TabFilters from "./TabFilters";
import Heading2 from "components/Heading/Heading2";
import ExperiencesCard from "./ExperiencesCard";
import { requestAPI } from "utils/api";
import LOGOimg from "assets/logo/allta.png";
import AlltaInfo  from '../../assets/logo/allta_intro.png';

import { productType } from "types/productType";
import { productCategory } from "types/productCategory";
import { Link } from "react-router-dom";

export interface SectionGridFilterCardProps {
  className?: string;
  data?: StayDataType[];
}

const DEMO_DATA: ExperiencesDataType[] = DEMO_EXPERIENCES_LISTINGS.filter(
  (_, i) => i < 8
);

const HomeGridFilterCard: FC<SectionGridFilterCardProps> = ({
  className = "",
  data = DEMO_DATA,
}) => {
	
	const tabs: any = productType;
	const [tabActive, setTabActive] = useState <any> (productType[0]);

	
	const tabs2: any = productCategory;
	const [tabActive2, setTabActive2] = useState <any> (productCategory[0]);


	const [datas, setDatas] = useState <any> ({
		oList: [],
		list: []
	});

	useEffect (() => {
		(async () => {
			const res: any = await requestAPI('GET', `v1/product`, null);

			//setList(res.data.list);
			const _datas = {
				oList: res.data.list,
				list: res.data.list,
			};

			setDatas(_datas);
			
			//updateData(res.data.list);
		})();
	}, [])

	const updateData = (_data: any) => {
		
		const _datas: any = {..._data};
		
		console.log("f1 ", _datas);

		let newDatas = [];

		newDatas = fillterTab(_datas.oList, "type", tabActive.key);
		newDatas = fillterTab(newDatas, "category", tabActive2.key);
		console.log("f2 ", newDatas);
		_datas.list = newDatas;
		
		setDatas (_datas);
	};

	const fillterTab = (_datas: any, key: string, value: string) => {
		
		let  v: any = [];

		if ( value === "all") {
			v = [..._datas];
		} else {
			_datas.forEach((item: any) => {
			
				if (item[key] === value) {
					v.push(item);
				}
			});
		}
		
		return v;
	}
	
	
	useEffect (() => {
		updateData (datas);
	}, [tabActive, tabActive2]);
  
	const renderTab = () => {
	  return (
		<ul 
			// className="ml-2 sm:ml-6 md:ml-12 flex space-x-5 sm:space-x-8 lg:space-x-11 overflow-x-auto hiddenScrollbar"
			className="grid grid-cols-3 rounded-full p-1 text-center text-md font-semibold leading-5 ring-1 ring-inset ring-gray-200 text-white"
		>
		  {tabs.map((tab: any, idx: number) => {
			
			const active = tab.key === tabActive.key;
			return (
				<li
					key={`tab_${idx}`}
					onClick={() => setTabActive(tab)}
					className={`cursor-pointer rounded-full gap-x-1 px-2.5 py-1 text-gray-500 ${
				  		active
						? "bg-red-700 text-white"
						: ""
					} `}

				>
					<span>{tab.label}</span>
			  	</li>
			);
		  })}
		</ul>
	  );
	};

	const renderTab2 = () => {
		return (
		  <ul 
			  // className="ml-2 sm:ml-6 md:ml-12 flex space-x-5 sm:space-x-8 lg:space-x-11 overflow-x-auto hiddenScrollbar"
			  className="grid grid-cols-4 text-center text-[0.9rem] font-bold leading-5 text-white"
		  >
			{tabs2.map((tab: any, idx: number) => {
			  
			  const active = tab.key === tabActive2.key;
			  return (
				  	<li
				  		key={`tab2_${idx}`}
						onClick={() => setTabActive2(tab)}
						className={`cursor-pointer rounded-full mr-3 px-3 py-1.5 text-gray-500 ${
							active
						  	? "bg-red-700 text-white"
						  	: "ring-1 ring-inset ring-gray-200"
					  	} `}
				  	>
						<span>{tab.label}</span>
					</li>
			  );
			})}
		  </ul>
		);
	};

	
	const renderTab3 = () => {
		return (
		  
		<div className="">
			<div className="mx-auto max-w-2xl lg:mx-0">
			<p className="mt-2 text-lg leading-8 text-red-700 font-bold">
				바이크로 떠나는 전세계 여행
			</p>
			</div>
			
			<ul
			role="list"
			className="mx-auto mt-5 grid w-full md:gap-x-4 gap-y-8 text-center grid-cols-5"
			>
			{tabs2.map((item: any) => (
				<li key={item.name}>
				<img alt="" src={`${process.env.REACT_APP_SERVER_FILE}/img/global/${item.key}.png`} className="mx-auto  rounded-full" />
				
				</li>
			))}
			</ul>
		</div>
		  
		)
	  }

	
	  //if (datas.list.length === 0) return (<></>);

	const emptyList = () => {
		return (
			<main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
				<div className="text-center">
					<p className="text-base font-semibold text-indigo-600">안내</p>
					<h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">등록된 상품이 없어요!</h1>
					<p className="mt-6 text-base leading-7 text-gray-600">해당 카테고리에 상품이 곧 등록될 예정이에요</p>
				
				</div>
			</main>
		)
	}

  	return (
		<div
			className={`nc-SectionGridFilterCard ${className}`}
			data-nc-id="SectionGridFilterCard"
		>
			<div className="pt-[20px]" />	
			
			{/* <div className={"w-full flex justify-center"}>
				<img className={"h-[100px]"} src={AlltaInfo} />
			</div> */}

			<div></div>

			<div className="pt-[20px]" />	
			<div className="flex justify-center">
				{renderTab()}
			</div>

			<div className="pt-[30px]" />
			<div className="flex justify-start pl-4">
				{renderTab3()}
			</div>

			
			{/* <div className="pt-[40px]" />
			<div className="flex justify-start pl-4">
				{renderTab2()}
			</div> */}


			
			<div className="pt-[30px] ml-4">
				<div className="mx-auto max-w-2xl lg:mx-0">
				<p className="mt-2 text-lg leading-8 text-red-700 font-bold">
					추천 상품
				</p>
				</div>
			</div>
			<div className="pt-[5px]">
				{
				datas.list.length > 0
				?
					<div className="mt-[16px] grid grid-cols-1 gap-6 grid-cols-2 ml-4 mr-4">
						{datas.list.map((item: any) => (
							<ExperiencesCard 
								key={item.no} 
								data={item} 
							/>
						))}
					</div>
				:
					emptyList()
				}
			</div>

			

			<div className="fixed bottom-4 right-4 flex flex-col gap-2 items-end z-50">
				<a
					href="https://www.facebook.com"
					target="_blank"
					rel="noopener noreferrer"
					className="p-3 rounded-full bg-indigo-600 text-white shadow-lg hover:bg-indigo-700 transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
				>
					<svg
						className="w-6 h-6 group-hover:mr-2"
						fill="currentColor"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
					</svg>
					<span className="hidden group-hover:inline whitespace-nowrap">Facebook</span>
				</a>
				
				<a
					href="https://www.instagram.com"
					target="_blank"
					rel="noopener noreferrer"
					className="p-3 rounded-full bg-indigo-600 text-white shadow-lg hover:bg-indigo-700 transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
				>
					<svg
						className="w-6 h-6 group-hover:mr-2"
						fill="currentColor"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
					</svg>
					<span className="hidden group-hover:inline whitespace-nowrap">Instagram</span>
				</a>

				<button
					onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
					className="p-3 rounded-full bg-indigo-600 text-white shadow-lg hover:bg-indigo-700 transition-all duration-300 ease-in-out w-12 flex items-center justify-center hover:w-[150px] group"
				>
					<svg
						className="w-6 h-6 group-hover:mr-2"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M5 10l7-7m0 0l7 7m-7-7v18"
						/>
					</svg>
					<span className="hidden group-hover:inline whitespace-nowrap">맨 위로 이동</span>
				</button>
			</div>

			<div className="p-5 bg-gray-100 text-gray-600 text-sm font-normal mt-10">
				<div className="pb-[5px]" />
				<div className="text-gray-400 text-2xl font-semibold">
					<span>allta</span>
				</div>
				<div className="mt-[15px]">
					<span>(주)올타</span>
					<span className="ml-1 mr-1">|</span>
					<span>대표이사 : 정성아</span>

					<span className="ml-1 mr-1">|</span>
					<span>사업자 등록번호 : 544-88-03223</span>
					{/* <span className="ml-1 mr-1">|</span>
					<span>통신판매업신고 : 경기-00000호</span> */}
					<span className="ml-1 mr-1">|</span>
					<span>메일 : hello@alltacompany.co.kr</span>
				</div>
				<div>
					<span>관광사업자 등록번호 : 제2024-000017호</span>
					<span className="ml-1 mr-1">|</span>
					<span>주소 : 경기도 화성시 동탄신리천로 270, 4층 402-186호 (오산동)</span>
					<span className="ml-1 mr-1">|</span>
					<span>호스팅서비스 제공자 : (주) 올타</span>
				</div>
				<span>고객센터 : 070-8057-6837 (오전 9시 - 오후 6시)</span>

				<div className="flex space-x-4 mt-4 text-gray-700 text-sm font-normal">
						<div>	
							<Link to={`/intro`}>
								<a
									className="underline py-1.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
								>
									회사소개
								</a>
							</Link>
						</div>
						<div>	
							<Link to={`/privacy`}>
								<a
									className="underline py-1.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
									>
									회원약관
								</a>
							</Link>
						</div>

						<div>	
							<Link to={`/security`}>
								<a
									className="underline py-1.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
									>
									개인정보 보안 정책
								</a>
							</Link>
						</div>
						<div>	
							<a
								href="mailto:hello@alltacompany.co.kr"
								className="underline py-1.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
							>
								광고 제휴 문의
							</a>
						</div>
				</div>
				<div className="mt-4 text-gray-600 text-sm font-normal">(주) 올타는 통신판매 중개자로서 통신판매의 당사자가 아니며 상품의 예약, 이용 및 환불 등과 관련한 의무와 책임은 각 판매자에게 있습니다.</div>
				<div className="mt-4 text-gray-600 text-sm font-normal">(주) 올타가 소유/운영/관리하는 웹사이트 및 앱 내의 상품/판매자/이벤트 정보, 디자인 및 화면의 구성, UI를 포함하여 일체의 콘텐츠에 대한 무단 복제, 배포, 방송 또는 전송, 스크래핑 등의 행위는 저작권법 및 콘텐츠산업 진흥법 등 관련 법령에 의하여 엄격히 금지 됩니다.</div>
				<div className="mt-[20px]" />
				<hr />
				<div className="pb-[200px]" />
			</div>

		</div>
  	);
};

export default HomeGridFilterCard;
